<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="510px"
    bodyHeight="300px"
    append-to-body
    top="25vh"
    class="edit-item-img-modal"
    @close="onChange"
  >
    <div slot="title">
      {{
        drawRow.type === 'add'
          ? $t('shop-site::facebook_campaign::add_staff')
          : $t('shop-site::facebook_campaign::edit_staff')
      }}
    </div>

    <el-form class="user-body" ref="form" :model="params" label-width="150px" label-suffix="：">
      <el-form-item :label="$t('shop-site::facebook_campaign::upload_avatar')" prop="img" class="input-box">
        <pictureUpload v-model="params.img" folder="campaign"></pictureUpload>
      </el-form-item>
      <div class="tip-content">
        {{ $t('shop-site::facebook_campaign::upload_avatar_tip') }}
      </div>
      <el-form-item
        :label="$t('shop-site::facebook_campaign::staff_name')"
        prop="userId"
        class="input-box"
        :rules="{ required: true, message: $t('shop-site::facebook::placeholder_account'), trigger: 'change' }"
      >
        <el-select
          filterable
          :loading="vloading"
          remote
          :remote-method="remoteMethod"
          :placeholder="$t('shop-site::facebook_campaign::placeholder_staff_name')"
          v-model="params.userId"
          class="input-item"
        >
          <el-option
            v-for="item in options"
            :key="item.userId"
            :label="item.loginName"
            :value="item.userId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item required class="input-box">
        <span slot="label">
          {{ $t('shop-site::facebook_campaign::campaign_name') }}
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              <span v-html="$t('shop-site::facebook_campaign::tooltip_campaign_name')"></span>
            </div>
            <i class="icon-a-01wenhao iconfont-el question-icon"></i>
          </el-tooltip>
        </span>
        <template v-for="(sign, index) in params.campaignSigns">
          <el-form-item
            class="mb-20"
            :key="index"
            :prop="`campaignSigns.${index}`"
            :rules="{ required: true, message: $t('shop-site::facebook::placeholder_accountId'), trigger: 'blur' }"
          >
            <el-input
              :placeholder="$t('shop-site::facebook_campaign::placeholder_campaign_name')"
              class="input-item"
              v-model="params.campaignSigns[index]"
              :maxlength="20"
            ></el-input>
            <span class="add-btn" @click="reduceSign(index)" v-if="params.campaignSigns.length > 1">
              <i class="el-icon-minus"></i>
            </span>
            <span class="add-btn" @click="addSign" v-if="index === params.campaignSigns.length - 1">
              <i class="el-icon-plus"></i>
            </span>
          </el-form-item>
        </template>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { saveOptimizingList, getTeamCamlist } from '@/server/marketing'
import pictureUpload from '@/components/common/picture-upload/index'
export default {
  name: 'campaign-modal',
  components: {
    pictureUpload,
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.$deepClone(this.drawRow)
      if (data.type === 'add') {
        this.params = {
          campaignSigns: [''],
          img: '',
          name: '',
          userId: '',
        }
      } else {
        this.params = {
          id: data.item.id,
          campaignSigns: data.item.campaignSigns,
          img: data.item.img,
          name: data.item.name,
          userId: data.item.userId,
        }
      }
      this.remoteMethod()
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true,
    },
  },
  data() {
    return {
      loading: false,
      vloading: false,
      options: [],
      tokens: [],
      file: undefined,
      rules: {
        sign: [{ required: true, message: this.$t('shop-site::facebook::placeholder_accountId'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('shop-site::facebook::placeholder_account'), trigger: 'change' }],
      },
      show: false,
      params: {},
    }
  },
  mounted() {},
  methods: {
    onChange() {
      this.$emit('change', false)
    },
    async remoteMethod(query) {
      this.vloading = true
      const data = await getTeamCamlist({
        keywords: query,
      })
      this.vloading = false
      if (data.data.code === this.$code) {
        this.options = data.data.data
      }
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          for (let item of this.params.campaignSigns) {
            if (!item) {
              return this.$message.warning(this.$t('shop-site::facebook::placeholder_accountId'))
            }
          }
          this.loading = true
          const user = this.options.find(item => item.userId === this.params.userId)
          console.log(user)
          let params = {
            ...this.params,
            name: (user && user.loginName) || '',
          }
          const { data } = await saveOptimizingList(params)
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save')
            this.$emit('change', false)
          }
          this.loading = false
        }
      })
    },
    addSign() {
      this.params.campaignSigns.push('')
    },
    reduceSign(index) {
      this.params.campaignSigns.splice(index, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-item-img-modal {
  ::v-deep {
    .el-dialog__body {
      min-height: inherit !important;
      max-height: inherit !important;
      // margin-right: 40px;
    }
  }
  .input-box {
    position: relative;
  }
  .question-icon {
    font-size: 14px;
    color: #999;
  }
  .user-body {
    .input-item {
      width: 220px;
    }
    .add-btn {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #f0f0f0;
      border-radius: 5px;
      margin-left: 8px;
      cursor: pointer;
      .el-icon-minus {
        color: #ff0022;
        font-weight: bold;
      }
      .el-icon-plus {
        color: #0560fd;
        font-weight: bold;
      }
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.tip-content {
  position: relative;
  top: -12px;
  font-size: 12px;
  color: $--color-info;
  padding-left: 140px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
